﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IPointLightNode } from '../kb3d-models';
import { KbVector } from '../primitives/kb-vector';
import { Token } from '../token';
import { ShadowLightNode } from './shadow-light-node';

@Kb3dModel({
    token: Token.PointLightNode,
})
export class PointLightNode extends ShadowLightNode implements IPointLightNode {
    constructor() {
        super();
    }

    public position: KbVector;
}
